// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2e016d2","884":"cd051988"}[chunkId] + ".chunk.js";
};